/* Raw Form cart — quantity changes through the Cart AJAX API.

   The section re-renders itself from the response (Section Rendering API), so
   the free-shipping meter, the totals and the cross-sell all stay in step
   without a page load. If anything goes wrong we submit the form, which is the
   same path a visitor without JS takes. */
class RFCart extends HTMLElement {
  connectedCallback() {
    this.sectionId = this.dataset.section;

    this.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-qty]');
      if (!btn) return;
      e.preventDefault();
      this.change(btn.dataset.line, parseInt(btn.dataset.to, 10));
    });

    this.addEventListener('change', (e) => {
      const input = e.target.closest('[data-qty-input]');
      if (!input) return;
      const n = parseInt(input.value, 10);
      this.change(input.dataset.line, Number.isNaN(n) || n < 0 ? 1 : n);
    });

    /* Enter in the number field would submit the form and reload the page. */
    this.addEventListener('keydown', (e) => {
      if (e.key !== 'Enter') return;
      const input = e.target.closest('[data-qty-input]');
      if (!input) return;
      e.preventDefault();
      input.blur();
    });
  }

  async change(line, quantity) {
    if (!line || this.busy) return;
    this.busy = true;
    this.setAttribute('data-busy', '');

    try {
      const res = await fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: Number(line), quantity, sections: this.sectionId })
      });
      if (!res.ok) throw new Error(res.status);
      const data = await res.json();

      const markup = data.sections && data.sections[this.sectionId];
      if (!markup) throw new Error('no section markup');

      /* The response carries the whole section wrapper, so take the matching
         element out of it rather than nesting one rf-cart inside another. */
      const fresh = new DOMParser().parseFromString(markup, 'text/html').querySelector('rf-cart');
      if (!fresh) throw new Error('no rf-cart in response');
      this.innerHTML = fresh.innerHTML;

      this.updateHeaderCount(data.item_count);
      document.dispatchEvent(new CustomEvent('rf:cart', { detail: data }));
    } catch (err) {
      const form = this.querySelector('.rf-cart__form');
      if (form) {
        form.submit();
        return;
      }
      window.location.assign(window.Shopify.routes.root + 'cart');
    } finally {
      this.busy = false;
      this.removeAttribute('data-busy');
    }
  }

  /* The header is a different section; one number is cheaper to patch than a
     second round trip to re-render it. */
  updateHeaderCount(count) {
    if (typeof count !== 'number') return;
    /* Count elements only — rewriting the link would wipe out the mobile bag. */
    document.querySelectorAll('[data-cart-count]').forEach((el) => (el.textContent = count));
    document.querySelectorAll('.rf-header__cart').forEach((a) =>
      a.setAttribute('aria-label', 'Cart, ' + count + (count === 1 ? ' item' : ' items'))
    );
  }
}

if (!customElements.get('rf-cart')) {
  customElements.define('rf-cart', RFCart);
}
